import {useEffect} from 'react'
import uniq from 'lodash/uniq.js'

import {
  ADDITIONAL_DEPENDENT_PROPERTIES,
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  SHIPPER_DEPENDENT_PROPERTIES,
  updateLabelPropertyChart,
} from '../../../data/labelInfos/index.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

export function formatMetaClassName(labelProperty) {
  return `meta-labelconfigform-input-${(labelProperty || '')
    .toLowerCase()
    .replace(/[-_]/, '')}`
}

export const EMPTY_DEPENDENT_PROPERTIES_FUNC = () => []

export const SHIPPER_DEPENDENT_PROPERTIES_FUNC = () =>
  SHIPPER_DEPENDENT_PROPERTIES
export const ADDITIONAL_DEPENDENT_PROPERTIES_FUNC = () =>
  ADDITIONAL_DEPENDENT_PROPERTIES
export const ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC = () =>
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES

export function defaultValidLabelPropertiesFunc(
  validShipperTypes,
  labelPropertiesFunc,
  labelInfoID,
) {
  return uniq(
    validShipperTypes.reduce(
      (prev, shipperType) => [
        ...prev,
        ...labelPropertiesFunc(shipperType, labelInfoID),
      ],
      [],
    ),
  )
}

/**
 * Hook to package up all the label property (preset) hooks and param defaulting
 *
 * @param {Object} props
 * @param {String} props.labelProperty
 * @param {Object} props.propertySpecs
 * @param {Function} props.propertySpecs.labelPropertiesFunc
 * @param {Array} props.propertySpecs.validShipperTypes
 * @param {Function} props.propertySpecs.dependentPropertiesFunc
 * @param {Function} props.propertySpecs.validLabelPropertiesFunc
 */
export default function useLabelProperty({labelProperty, propertySpecs}) {
  const {labelInfoID, isLabelEnableMode} = useLabelConfigContext()

  useEffect(() => {
    if (!isLabelEnableMode) {
      return
    }

    updateLabelPropertyChart(labelInfoID, labelProperty, propertySpecs)
  }, [labelProperty])
}
